import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/onaylarimLogo01.png'


const _hoisted_1 = { class: "min-h-screen bg-white flex" }
const _hoisted_2 = { class: "flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24" }
const _hoisted_3 = { class: "mx-auto w-full max-w-sm lg:w-96" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "h-12 w-auto",
    src: _imports_0,
    alt: "Workflow"
  }),
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-6 text-3xl font-extrabold text-gray-900" }, "Belgenizi e-imzalayın")
], -1)
const _hoisted_5 = { class: "mt-8" }
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = { class: "space-y-6" }
const _hoisted_8 = { class: "space-y-1 text-center" }
const _hoisted_9 = { class: "text-sm text-gray-600" }
const _hoisted_10 = {
  for: "file",
  class: "relative cursor-pointer bg-white rounded-md font-medium text-sky-600 hover:text-sky-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-sky-500"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "İmzalanacak dosyanızı seçin", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600" }, "veya buraya sürükleyip bırakın", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, "PDF, Word, Excel, PowerPoint veya resim dosyaları (max 2MB)", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-sky-600 hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
  }, " Sign in ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentAddIcon = _resolveComponent("DocumentAddIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _createElementVNode("div", {
                  class: "flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addFileFromComputer && _ctx.addFileFromComputer(...args)))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_DocumentAddIcon, { class: "mx-auto h-12 w-12 text-gray-400" }),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("label", _hoisted_10, [
                        _hoisted_11,
                        _hoisted_12,
                        _createElementVNode("input", {
                          type: "file",
                          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitFile())),
                          ref: "file",
                          class: "sr-only"
                        }, null, 544)
                      ])
                    ]),
                    _hoisted_13
                  ])
                ])
              ]),
              _hoisted_14
            ])
          ])
        ])
      ])
    ])
  ]))
}